module.exports = __webpack_public_path__ + "static/media/youtube.01bc8454.svg";